import { default as RCTable } from 'rc-table';

import { useSelectionContext } from '../utils/selectHelpers';

/**
 * Helper function to check if the table needs an summary row
 *
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
export const hasSummary = (columns) => {
  return columns?.some((column) => column.summary != null) ?? false;
};

/**
 * SUMMARY BLOCK: Optional auto-generated summary section of the table.
 *
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const SummaryBlock = ({ columns, canExpand }) => {
  const selectionContext = useSelectionContext();

  const assemblyArray = [];

  if (canExpand) {
    assemblyArray.push({
      index: 0,
      value: null,
      colSpan: 1,
      key: [columns[0].key + '_summary' + '_expandCell'],
    });
  }

  if (selectionContext != null) {
    assemblyArray.push({
      index: assemblyArray.length,
      value: null,
      colSpan: 1,
      key: [columns[0].key + '_summary' + '_selectCell'],
    });
  }

  const indexModifier = assemblyArray.length;

  columns.forEach((column, index) => {
    assemblyArray.push({
      index: index + indexModifier,
      key: column.key + '_summary',
      value: column.summary || null,
    });
  });

  return (
    <RCTable.Summary.Row>
      {assemblyArray.map((summaryCell, index) => {
        const className =
          (summaryCell.value == null ? ' summary-empty' : '') +
          (assemblyArray[index + 1] != null
            ? summaryCell.value == null &&
              assemblyArray[index + 1].value != null
              ? ' summary-empty-before-full'
              : ''
            : '');
        return (
          <RCTable.Summary.Cell
            key={summaryCell.key}
            index={summaryCell.index}
            colSpan={summaryCell.colSpan}
            className={className}
          >
            {summaryCell.value}
          </RCTable.Summary.Cell>
        );
      })}
    </RCTable.Summary.Row>
  );
};
export default SummaryBlock;
